import styles from "./Subscriptions.module.scss";
import { useTranslation } from "react-i18next";
import MainTitle from "../../../components/ui/MainTitle/MainTitle";
import React, { useEffect, useState } from "react";
import SubscriptionPopup from "./SubscriptionPopup/SubscriptionPopup";
import SubscriptionItem from "./SubscriptionItem/SubscriptionItem";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetAllSubscriptionsQuery } from "../../../api/queries";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import plusIconWhite from "../../../assets/images/icons/plus-white.svg";
import Empty from "../Empty/Empty";
import SubscriptionsEmpty from "./SubscriptionsEmpty/SubscriptionsEmpty";

const Subscriptions = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState<string | null>(null);
  const [showCreatePopup, setShowCreatePopup] = useState<boolean>(false);
  const {
    data: subscriptionList = [],
    isLoading,
    refetch,
  } = useGetAllSubscriptionsQuery(searchValue);

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const shouldUpdate = searchParams.get("shouldUpdateSubscriptions");
      if (searchParams.get("searchValue") !== searchValue) {
        setSearchValue(searchParams.get("searchValue"));
      }
      if (shouldUpdate) {
        refetch();
      }
      navigate("/subscriptions");
    }
  }, [location]);

  const onClickAddNew = () => {
    setShowCreatePopup(true);
  };

  return (
    <div className={"page-content"}>
      <div className={styles.top}>
        <MainTitle
          text={t("SubscriptionPlans")}
          subtitleText={t("TheCreditBundlesClientsPurchaseToBookClasses")}
        />
        <div className={styles.btnWrapper}>
          <CustomButton
            text={t("AddSubscription")}
            type={"button"}
            typeStyle={"fill"}
            icon={plusIconWhite}
            altIcon={"add"}
            functionOnClick={onClickAddNew}
          />
        </div>
      </div>
      <div className={styles.wrapper}>
        {!!subscriptionList.length &&
          subscriptionList.map((el) => {
            return <SubscriptionItem key={el.id} item={el} />;
          })}
      </div>
      {subscriptionList.length === 0 && !isLoading && (
        <SubscriptionsEmpty onClickAddNew={onClickAddNew} />
      )}

      {showCreatePopup && <SubscriptionPopup setShowCreatePopup={setShowCreatePopup} item={null} />}
    </div>
  );
};

export default Subscriptions;
